import { CrmEntityType, PrismaClient } from '@prisma/client';

export type CrmSyncRecordClient = Pick<PrismaClient, 'crmSyncRecord'>;
export type CrmSyncRecordRawClient = Pick<PrismaClient, '$executeRaw'>;

export type DiscoveredRecord = {
  entityType: CrmEntityType;
  entityId: string;
  /** INVOICE only. True marks a discovery-time ineligible row permanently terminal. */
  isTerminal?: boolean;
};

export type ScrubbableError = { category?: string; id?: string; message: string };

export type SyncOutcome =
  | { kind: 'success'; recordId: number; crmObjectId?: string; isTerminal?: boolean }
  | { kind: 'unchanged'; recordId: number }
  | { kind: 'self-heal'; recordId: number; crmObjectId?: string }
  | { kind: 'unresolvable'; recordId: number }
  | {
      kind: 'failure';
      recordId: number;
      entityId?: string;
      failureCount: number;
      crmObjectId?: string;
      error: ScrubbableError;
    };
